<ul>
  <li *ngFor="let shortcut of shortcuts">
    <sbnb-shortcut-link [shortcut]="shortcut"></sbnb-shortcut-link>
  </li>
</ul>
